import { fmtInitials, avatarColor } from '../../utils/avatar';

interface GuestAvatarProps {
  id: string;
  first_name?: string | null;
  last_name?: string | null;
  size?: 32 | 38;
  pair?: boolean;
}

export default function GuestAvatar({ id, first_name, last_name, size = 32, pair }: GuestAvatarProps) {
  return (
    <span
      className={`st-av${size === 38 ? ' st-av--lg' : ''}${pair ? ' st-av--pair' : ''}`}
      style={{ background: avatarColor(id) }}
    >
      {fmtInitials({ first_name, last_name })}
    </span>
  );
}
